import React, { Component } from 'react'
import {StyledMain }  from '../styled/StyledMain'
import Cards from './Cards'
import {CardFixed} from './CardFixed'
import { Panel } from './Panel';
import { data } from '../data/data.js'


export class Main extends Component { 
   
    constructor() {
        super();
        this.state = {
            business: data,
            skil:[],
            panel: false,
            idx: 0,
        };
      
      }

      componentDidMount() {
         
          };
            
          showPanel = (e) => {
            this.setState({
              panel: true,
              idx: e.target.id -1,
            });
          }
          closePanel = (e) => {
            this.setState({
              panel: false,
            });
      
      }
      handleSubmit = (e) => {
        e.preventDefault()
        console.log(e.target.classList.contains("img"))
       
    }
      
  render() {
    return (
      <div>
          <StyledMain>
            {this.state.panel === true && (
              <Panel idx={this.state.idx} clearPanel={this.closePanel}/>
            )}
            <div onClick={this.showPanel}>
              {/* <CardFixed/> */}
              {this.state.business.map((job, index) => (
                <Cards key={index} jobs={job} idx={this.state.idx}/>
                ))}
            </div>
          </StyledMain>
      </div>
    );
  }
}

export default Main
